document.addEventListener('DOMContentLoaded', () => {
  const drawerDialog = document.querySelector('.cart-drawer__dialog');
  if (!drawerDialog) {
    console.warn('⚠️ cart-drawer__dialog element not found');
    return;
  }
  // --- Update free shipping progress bar and message ---
  function updateFreeShippingBar() {
    const FREE_SHIPPING_THRESHOLD = 200;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price / 100; // from cents to dollars
        const progressPercent = Math.min((cartTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);

        const progressBar = document.getElementById('progress-bar');
        const message = document.getElementById('free-shipping-message');

        if (progressBar && message) {
          progressBar.style.width = progressPercent + '%';

          if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
            message.textContent = "You’ve unlocked Free Shipping!";
          } else {
            const remaining = (FREE_SHIPPING_THRESHOLD - cartTotal).toFixed(2);
            message.textContent = `You are $${remaining} away from Free Shipping!`;
          }
        } else {
          console.warn('⚠️ Progress bar or message element missing');
        }
      })
      .catch(err => console.error('Error fetching cart:', err));
  }

  // --- Observe changes inside cart items container to update progress dynamically ---
  function setupCartItemsObserver() {
    const cartItemsContainer = document.querySelector('.cart-items-component');
    if (!cartItemsContainer) {
      console.warn('⚠️ cart items container not found for MutationObserver');
      return;
    }

    const observer = new MutationObserver(() => {
      // Debounce the update to avoid rapid firing
      if (window.updateFreeShippingTimeout) {
        clearTimeout(window.updateFreeShippingTimeout);
      }
      window.updateFreeShippingTimeout = setTimeout(() => {
        console.log('Cart items changed — updating free shipping bar');
        updateFreeShippingBar();
      }, 300);
    });

    observer.observe(cartItemsContainer, { childList: true, subtree: true });
    console.log('👀 MutationObserver set on cart items container');
  }

  // --- Observe open attribute changes on the cart drawer dialog ---
  const drawerObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        if (drawerDialog.hasAttribute('open')) {
          updateFreeShippingBar();
          setupCartItemsObserver();
        } else {
          console.log('Cart drawer closed');
        }
      }
    });
  });

  drawerObserver.observe(drawerDialog, {
    attributes: true,
    attributeFilter: ['open']
  });
  if (drawerDialog.hasAttribute('open')) {
    updateFreeShippingBar();
    setupCartItemsObserver();
  }
});

// ---------- SLIDERS  ---------- //

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.listing-slider-one', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      // dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.listing-slider-product', {
    loop: true,
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      // dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});

document.querySelectorAll('.listing-slider-blog').forEach(function (slider) {
  const slides = slider.querySelectorAll('.article-card');
  if (slides.length > 3) {
    new Swiper(slider, {
      loop: true,
      slidesPerView: 'auto',
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
    });
    slider.classList.add('is-slider');
  } else {
    slider.classList.add('is-static');
  }
});

// ---------- BRANDS DESKTOP LAYOUT  ---------- //

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".wrapper-listing-brand");
  const imageDisplay = document.querySelector("#hover-image-display");
  const column = section.querySelector(".column");
  const headerHeight = 0;
  let scrollTimeout;
  function handleScroll() {
    const sectionTop = section.offsetTop;
    const columnHeight = column.offsetHeight;
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const scrollBottom = scrollY + windowHeight;
    const startFix = sectionTop;
    const endFix = sectionTop + columnHeight;
    if (scrollY >= startFix && scrollBottom <= endFix + headerHeight) {
      // Inside scrolling range
      imageDisplay.style.position = "fixed";
      imageDisplay.style.top = headerHeight + "px";
      imageDisplay.style.bottom = "auto";
    } else if (scrollBottom > endFix + headerHeight) {
      // After the section
      imageDisplay.style.position = "absolute";
      imageDisplay.style.top = "auto";
      imageDisplay.style.bottom = "0";
    } else {
      // Before the section
      imageDisplay.style.position = "absolute";
      imageDisplay.style.top = headerHeight + "px";
      imageDisplay.style.bottom = "auto";
    }
    // On scroll: set z-index to -1
    imageDisplay.style.zIndex = "-1";
    // Clear any existing timeout
    clearTimeout(scrollTimeout);
    // Reset z-index to 1 after 150ms of no scroll
    scrollTimeout = setTimeout(() => {
      imageDisplay.style.zIndex = "1";
    }, 150);
  }
  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleScroll);
  handleScroll(); // Run initially
  // Hover image swap
  const hoverItems = document.querySelectorAll(".hover-item");
  hoverItems.forEach(item => {
    item.addEventListener("mouseenter", () => {
      const imageUrl = item.dataset.image;
      if (imageUrl && !imageUrl.includes("Liquid error")) {
        imageDisplay.style.backgroundImage = `url(${imageUrl})`;
      }
    });
  });
});

// ---------- Show and hide mobile menu  ---------- //

document.addEventListener('DOMContentLoaded', function() {
  const menuWrapper = document.querySelector('.wrapper-menu-mobile');
  const menuMobile = menuWrapper.querySelector('.menu-mobile');

  // Event delegation for open/close/submenu
  document.addEventListener('click', function(e) {
    const target = e.target;

    // Open menu
    if (target.classList.contains('menu-open')) {
      menuWrapper.classList.add('active');
    }

    // Close menu
    if (target.classList.contains('menu-close')) {
      menuWrapper.classList.remove('active');
    }

    // Toggle submenu
    if (target.classList.contains('menu-parent')) {
      e.stopPropagation();
      const li = target.parentElement;
      const submenu = li.querySelector('ul');
      if (submenu) {
        submenu.classList.toggle('open');
        target.classList.toggle('open');
      }
    }
  });
});


// ---------- Show and hide mega menu  ---------- //

// document.querySelectorAll('[datahover]').forEach(trigger => {
//   const targetId = trigger.getAttribute('datahover');
//   trigger.addEventListener('mouseenter', () => {
//     // Always hide all menus first
//     document.querySelectorAll('.wrapper-menu-mega').forEach(menu => {
//       menu.classList.remove('show');
//     });
//     // Try to show the one related to this trigger (if it exists)
//     const targetContent = document.getElementById(targetId);
//     if (targetContent) {
//       const megaMenu = targetContent.closest('.wrapper-menu-mega');
//       if (megaMenu) {
//         megaMenu.classList.add('show');
//       }
//     }
//   });
// });
// // Hide all mega menus when mouse leaves the header or menus area
// document.addEventListener('mouseover', (e) => {
//   const isTrigger = e.target.closest('[datahover]');
//   const isMenu = e.target.closest('.wrapper-menu-mega');
//   const isHeader = e.target.closest('.header-section');

//   if (!isTrigger && !isMenu && !isHeader) {
//     document.querySelectorAll('.wrapper-menu-mega').forEach(menu => {
//       menu.classList.remove('show');
//     });
//   }
// });
// Hover logic (your existing code)
document.querySelectorAll('[datahover]').forEach(trigger => {
  const targetId = trigger.getAttribute('datahover');
  trigger.addEventListener('mouseenter', () => {
    // Hide all menus first
    document.querySelectorAll('.wrapper-menu-mega').forEach(menu => {
      menu.classList.remove('show');
    });
    // Show the one related to this trigger
    const targetContent = document.getElementById(targetId);
    if (targetContent) {
      const megaMenu = targetContent.closest('.wrapper-menu-mega');
      if (megaMenu) {
        megaMenu.classList.add('show');
      }
    }
  });
});

// Hide all mega menus when mouse leaves header or menu area
document.addEventListener('mouseover', (e) => {
  const isTrigger = e.target.closest('[datahover]');
  const isMenu = e.target.closest('.wrapper-menu-mega');
  const isHeader = e.target.closest('.header-section');

  if (!isTrigger && !isMenu && !isHeader) {
    document.querySelectorAll('.wrapper-menu-mega').forEach(menu => {
      menu.classList.remove('show');
    });
  }
});

// New: hide menus on scroll
window.addEventListener('scroll', () => {
  document.querySelectorAll('.wrapper-menu-mega').forEach(menu => {
    menu.classList.remove('show');
  });
});



// ---------- Adjust height of the header based on the notification bar ---------- //

function adjustMegaMenuPositions() {
  const notifBar = document.getElementById('notification-bar');
  const header = document.querySelector('.header-section');
  const megaMenus = document.querySelectorAll('.wrapper-menu-mega');

  if (!header || megaMenus.length === 0) return;

  let notifHeight = 0;
  if (notifBar) {
    const rect = notifBar.getBoundingClientRect();
    notifHeight = Math.max(0, rect.bottom);
  }

  const headerHeight = header.offsetHeight || 0;
  const totalOffset = notifHeight + (headerHeight - 1);

  megaMenus.forEach(menu => {
    menu.style.top = `${totalOffset}px`;
  });
}

window.addEventListener('load', adjustMegaMenuPositions);
window.addEventListener('scroll', adjustMegaMenuPositions);
window.addEventListener('resize', adjustMegaMenuPositions);


// ---------- Show/Hide Filter ---------- //


// const filterBtn = document.querySelector('#filter');
// const popup = document.querySelector('.popup-filters');
// const closeBtn = popup.querySelector('.btn-filter-close');
// // Open popup
// filterBtn.addEventListener('click', () => {
//   popup.classList.add('show');
// });
// // Close popup on close button click
// closeBtn.addEventListener('click', () => {
//   popup.classList.remove('show');
// });


// ---------- Product Filters ---------- //


document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('.popup-filters');
  const filterBtn = document.getElementById('filter');
  const closeBtn = document.querySelector('.btn-filter-close');
  const filterForm = document.getElementById('CollectionFiltersForm');
  const productGrid = document.querySelector('#ProductGrid');

  let isPopupOpen = false;

  // --- Popup open/close ---
  filterBtn?.addEventListener('click', () => {
    popup.classList.add('show');
    isPopupOpen = true;
  });

  closeBtn?.addEventListener('click', () => {
    popup.classList.remove('show');
    isPopupOpen = false;
  });

  // --- AJAX filtering ---
  filterForm?.addEventListener('change', async () => {
    const formData = new FormData(filterForm);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Fetch error: ${response.status}`);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const newGrid = doc.querySelector('#product-grid');
      document.querySelector('#product-grid').innerHTML = newGrid.innerHTML;
      if (newGrid && productGrid) {
        productGrid.innerHTML = newGrid.innerHTML;
      }

      // Keep popup open after update
      if (isPopupOpen) popup.classList.add('show');

      // Update browser URL (no reload)
      window.history.replaceState({}, '', url);
    } catch (error) {
      console.error('Filter AJAX failed:', error);
    }

  });
});


// ---------- Product Quick Add ---------- //

function initializeProductCards(context = document) {
  context.querySelectorAll('.product-card').forEach(function (card) {
    // Prevent re-initializing the same card
    if (card.dataset.initialized === 'true') return;
    card.dataset.initialized = 'true';

    const variants = JSON.parse(card.dataset.variants);
    const variantIdInput = card.querySelector('.variant-id');
    const imageEl = card.querySelector('img.product-image');
    const priceEl = card.querySelector('.price');
    const compareAtEl = card.querySelector('.compare-at');
    const optionGroups = card.querySelectorAll('[data-option-index]');

    const numOptions = optionGroups.length;
    let selectedOptions = [];

    function updateAvailableOptions() {
      const hasColors = optionGroups.length > 1;
      // If only 1 option group, treat it as size-only

      optionGroups.forEach(group => {
        const optionIndex = parseInt(group.dataset.optionIndex, 10);
        const options = group.querySelectorAll('.option');

        options.forEach(option => {
          const value = option.dataset.value;
          let tempSelection = [...selectedOptions];
          tempSelection[optionIndex] = value;

          const exists = variants.some(variant => {
            return variant.available && variant.options.every((opt, i) => {
              return !tempSelection[i] || tempSelection[i] === opt;
            });
          });

          const isColorGroup = hasColors && optionIndex === 0;

          if (isColorGroup) {
            // Colors NEVER disabled
            option.classList.remove('disabled');
            option.removeAttribute('aria-disabled');
          } else {
            // Sizes (or only options) follow availability
            if (!exists) {
              option.classList.add('disabled');
              option.setAttribute('aria-disabled', 'true');
            } else {
              option.classList.remove('disabled');
              option.removeAttribute('aria-disabled');
            }
          }
        });
      });
    }


    function updateSelection(optionIndex, value, group) {
      selectedOptions[optionIndex] = value;

      group.querySelectorAll('.option').forEach(el => el.classList.remove('active'));
      group.querySelector(`.option[data-value="${value}"]`)?.classList.add('active');

      const matched = variants.find(v =>
        v.options.every((val, i) => selectedOptions[i] === val)
      );

      if (matched) {
        variantIdInput.value = matched.id;
        if (matched.featured_image && imageEl) imageEl.src = matched.featured_image.src;
        if (priceEl) priceEl.textContent = formatMoney(matched.price);

        if (compareAtEl) {
          if (matched.compare_at_price > matched.price) {
            compareAtEl.style.display = 'inline';
            compareAtEl.textContent = formatMoney(matched.compare_at_price);
          } else {
            compareAtEl.style.display = 'none';
          }
        }
      }

      updateAvailableOptions();
    }

    // Auto-select first available variant
    const initialVariant = variants.find(v => v.available);
    if (initialVariant) {
      selectedOptions = initialVariant.options.slice();
      optionGroups.forEach(group => {
        const index = parseInt(group.dataset.optionIndex, 10);
        const value = selectedOptions[index];
        group.querySelectorAll('.option').forEach(el => {
          el.classList.toggle('active', el.dataset.value === value);
        });
      });
      variantIdInput.value = initialVariant.id;
      if (initialVariant.featured_image && imageEl) imageEl.src = initialVariant.featured_image.src;
      if (priceEl) priceEl.textContent = formatMoney(initialVariant.price);
      if (compareAtEl) {
        if (initialVariant.compare_at_price > initialVariant.price) {
          compareAtEl.style.display = 'inline';
          compareAtEl.textContent = formatMoney(initialVariant.compare_at_price);
        } else {
          compareAtEl.style.display = 'none';
        }
      }
      updateAvailableOptions();
    }

    // Click handlers
    optionGroups.forEach(group => {
      const optionIndex = parseInt(group.dataset.optionIndex, 10);
      group.querySelectorAll('.option').forEach(option => {
        const value = option.dataset.value;
        option.addEventListener('click', () => {
          if (option.classList.contains('disabled')) return;
          updateSelection(optionIndex, value, group);
        });
      });
    });

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  });


}




document.addEventListener('DOMContentLoaded', () => {
  initializeProductCards();
  const viewMoreBtn = document.getElementById('view-more');

  if (viewMoreBtn) {
    viewMoreBtn.addEventListener('click', async () => {
      const nextUrl = viewMoreBtn.dataset.nextUrl;
      if (!nextUrl) return;

      try {
        viewMoreBtn.disabled = true;
        viewMoreBtn.textContent = 'Loading...';

        const response = await fetch(nextUrl);
        const text = await response.text();

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;

        const newProducts = tempDiv.querySelectorAll('#product-grid > *');
        const productGrid = document.getElementById('product-grid');

        newProducts.forEach(product => {
          productGrid.appendChild(product);
        });

        // Reinitialize the newly added product cards
        initializeProductCards(productGrid);

        // Update or remove View More button
        const newBtn = tempDiv.querySelector('#view-more');
        if (newBtn) {
          viewMoreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
          viewMoreBtn.disabled = false;
          viewMoreBtn.textContent = 'View More';
        } else {
          viewMoreBtn.closest('.pagination')?.remove();
        }
      } catch (err) {
        console.error('Failed to load more products:', err);
        viewMoreBtn.textContent = 'Try Again';
        viewMoreBtn.disabled = false;
      }
    });
  }
});



// ---------- Tony Hawk Pro Skater ---------- //

document.addEventListener("keydown", function(e) {

  // Define trick sequences
  const tricks = {
    kickflip: ["ArrowLeft", "x"],
    popshoveit: ["ArrowDown", "x"]
  };

  if (!window.trickState) {
    window.trickState = { kickflip: 0, popshoveit: 0 };
  }
  for (let trick in tricks) {
    const sequence = tricks[trick];
    let step = window.trickState[trick];

    if (e.key === sequence[step]) {
      step++;
      if (step === sequence.length) {
        const el = document.body;
        el.classList.remove(trick);
        void el.offsetWidth;
        el.classList.add(trick);
        step = 0;
      }
    } else if (e.key === sequence[0]) {
      step = 1;
    } else {
      step = 0;
    }
    window.trickState[trick] = step;
  }
});
document.body.addEventListener("animationend", function(e) {
  if (e.animationName === "kickflip") {
    document.body.classList.remove("kickflip");
  }
  if (e.animationName === "popshoveit") {
    document.body.classList.remove("popshoveit");
  }
});

// ---------- OPEN/CLOSE POPUP ---------- //

document.addEventListener('DOMContentLoaded', () => {
  const popupOpen = document.querySelector('.popup-open');
  const popupRow = document.querySelector('.wrapper-popup .row');
  const popupClose = document.querySelector('.popup-close');

  if (!popupOpen || !popupRow || !popupClose) return;

  // Open popup
  popupOpen.addEventListener('click', () => {
    popupRow.classList.add('show');
  });

  // Close popup
  popupClose.addEventListener('click', () => {
    popupRow.classList.remove('show');
  });

  // Optional: click outside popup to close
  popupRow.addEventListener('click', e => {
    if (e.target === popupRow) {
      popupRow.classList.remove('show');
    }
  });

  // Optional: Esc key closes popup
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      popupRow.classList.remove('show');
    }
  });
});
